import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Link } from "../../atoms/link";
import { memo } from "react";
import { cn } from "@discovery/classnames";
export const NavigationItem = memo(({ title, type, src, altSrc, url, isSelected = false, onClickM = M.empty(), }) => {
    return (React.createElement(Link, { href: url },
        React.createElement(React.Fragment, null, window.innerWidth > 699 ? (React.createElement("div", { onClick: M.fromMaybe(onClickM, () => { }), className: styles.headerNavigationWeb, id: `#d${title}` },
            React.createElement("div", { className: cn(styles.defaultText, {
                    [styles.selectedText]: isSelected,
                }) },
                React.createElement("div", { id: isSelected ? `#activeD${title}` : `#nonActiveD${title}` }, title)))) : (React.createElement("div", { className: styles.mobile },
            React.createElement("div", { className: type === "basic"
                    ? styles.menuContainerBasic
                    : styles.menuContainerEmphasize, onClick: M.fromMaybe(onClickM, () => { }) },
                isSelected ? altSrc : src,
                React.createElement("div", { className: cn(styles.defaultText, {
                        [styles.selectedText]: isSelected,
                    }), id: isSelected ? `#activeD${title}` : `#nonActiveD${title}` }, title)))))));
});

